module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-modal', {
    attrs: {
      "visible": _vm.visible,
      "title": "绑定关联地块vr",
      "footer": null,
      "afterClose": _vm.afterClose,
      "maskClosable": false
    },
    on: {
      "cancel": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 12
      }
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "选择地块"
    }
  }, [_c('a-select', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['value', {
        rules: [{
          required: true,
          message: '请选择'
        }]
      }]),
      expression: "['value', { rules: [{ required: true, message: '请选择' }] }]"
    }],
    staticStyle: {
      "width": "120px"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('a-select-option', {
      key: option.vrId,
      attrs: {
        "value": option.vrId
      }
    }, [_vm._v(_vm._s(option.areaName))])
  }), 1)], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "wrapper-col": {
        span: 12,
        offset: 5
      }
    }
  }, [_c('a-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("确认")]), _vm._v(" "), (_vm.vrId) ? _c('a-button', {
    on: {
      "click": _vm.toLandByVr
    }
  }, [_vm._v("查看VR")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c1c7160","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/ChooseLand.vue
// module id = 1072
// module chunks = 1